import { Tree } from 'antd';
import * as React from 'react';
import { Subscribe } from 'unstated';

import DeliveryMethods from '../../../components/Query/DeliveryMethods';
import { StateContainer } from './StateContainer';
import { FormItem } from '../../../components/Form';
import ProductSelect from '../../../components/Others/ProductSelect';
import CustomerGroupTree from '../../../components/Others/CustomerGroupTree';
import CustomerSelect from '../../../components/Others/CustomerSelect';

export interface IValueSettingsColProps {
  container: StateContainer;
  domain: string;
  isIndividualCustomerVoucher?: boolean;
}

export interface IValueSettingsColState {
  valueIndex?: any;
}

export default class ValueSettingsCol extends React.Component<IValueSettingsColProps, IValueSettingsColState> {

  public render() {
    const { container } = this.props;

    return (
      <Subscribe to={[container]}>
        {voucherGroup => (
          <>
            {this.props.isIndividualCustomerVoucher
              && <FormItem label={'For customer'}>
                <CustomerSelect
                  name={'customerIds'}
                  value={Array.isArray(voucherGroup.state.voucherGroup.customerIds) ? voucherGroup.state.voucherGroup.customerIds : undefined}
                  multiple={true}
                  onChange={(e: any) => container.onChange('customerIds', e.target.value)}
                  domain={this.props.domain}
                />
              </FormItem>
              || <FormItem label={'For customers group'}>
              <CustomerGroupTree
                name={'customerGroupsIds'}
                onChange={(e: any, customerGroups: GQL.ICustomerGroup[]) => container.setState({ customerGroupsIds: e.target.value })}
                value={voucherGroup.state.customerGroupsIds || []}
              />
            </FormItem>}
            <FormItem label={'Free shipping'}>
              <DeliveryMethods
                domain={this.props.domain}
              >
                {({ deliveryMethods }: any) => {
                  if (deliveryMethods.loading) {
                    return <span>loading</span>;
                  }

                  return (
                    <Tree
                      onCheck={(checkedKeys: any) =>
                        container.setState({ selectedDeliveryMethodIds: checkedKeys.checked })
                      }
                      onSelect={(checkedKeys: any) =>
                        container.setState({ selectedDeliveryMethodIds: checkedKeys })
                      }
                      selectedKeys={voucherGroup.state.selectedDeliveryMethodIds}
                      checkedKeys={voucherGroup.state.selectedDeliveryMethodIds}
                      multiple={true}
                      checkable={true}
                      checkStrictly={true}
                      treeData={deliveryMethods.deliveryMethods.map((p: GQL.IPaymentMethod) => {
                        p.key = p.id
                        return p;
                      })}
                    />
                  );
                }}
              </DeliveryMethods>
            </FormItem>
            {(!this.props.isIndividualCustomerVoucher) && <FormItem label={'Available for products'}>
              <ProductSelect
                name={'includedProductIds'}
                multiple={true}
                value={(voucherGroup.state.includedProductIds || []).map(v => v) || []}
                onChange={(e: any) => {
                  container.setState({ includedProductIds: e.target.value });
                }}
              />
            </FormItem> || ''}
          </>
        )}
      </Subscribe>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/VoucherGroups/VoucherGroupDetail/ValueSettingsCol.tsx